import type { Money } from '../../../lib/Money.ts';
import type { EditableBillLineItemWire } from './editableBillMapping.ts';

export type EditorLine = {
    lineItemId: string;
    description: string;
    netAmount: Money | null;
};

export type ScannedTotalLine = {
    lineItemId: string;
    description: string;
    totalAmount: Money;
};

export function findLinesWithOnlyScannedTotal(
    scannedLineItems: EditableBillLineItemWire[],
    editorLines: EditorLine[],
): ScannedTotalLine[] {
    return editorLines.flatMap(({ lineItemId, description, netAmount }) => {
        const totalAmount = scannedLineItems.find((item) => item.id === lineItemId)?.total_amount as Money | null | undefined;
        if (!totalAmount || netAmount) {
            return [];
        }
        return [{ lineItemId, description, totalAmount }];
    });
}
